import * as React from 'react'
import * as Dialog from 'primitives/dialog'
import { useUpdateUserGdprConsentMutation } from 'codegen/generated/cf'
import type { NewsletterPopup as NewsletterPopupType } from 'codegen/types'
import { UserUpdateGdprConsent } from 'codegen/types'
import { useIsLoggedInQuery, useUserIdQuery } from 'auth/hooks'

export function NewsletterPopup({ popup }: { popup: NewsletterPopupType }) {
  const { title, text, closeText, footerText, backgroundImageSrc, button } = popup
  const { text: buttonText } = button
  const isUserLoggedInQuery = useIsLoggedInQuery()
  const userIdQuery = useUserIdQuery()
  const updateUserGdprConsentMutation = useUpdateUserGdprConsentMutation()
  const [isOpen, setIsOpen] = React.useState(true)

  const handleGDPRAnswer = (answer: UserUpdateGdprConsent) => {
    if (isUserLoggedInQuery.data) {
      updateUserGdprConsentMutation.mutate({
        input: {
          userID: userIdQuery.data || '',
          consent: answer,
          page: window.location.pathname,
        },
      })
    }
    setIsOpen(false)
  }

  const handleOnOpenChange = (open: boolean) => {
    if (!open) {
      setIsOpen(false)
    }
  }

  return (
    <div className="font-poppins relative z-[9001]">
      <Dialog.Root open={isOpen} onOpenChange={handleOnOpenChange}>
        <Dialog.Body dismissable={false}>
          <div
            style={{
              backgroundImage: `url(${backgroundImageSrc})`,
            }}
            className="bg-aubergine-500 text-service-white flex w-full flex-col items-center gap-5 bg-cover bg-center bg-no-repeat p-[50px] text-center md:max-w-[420px]"
          >
            <h3 className="text-24 w-[50%] font-bold">{title}</h3>
            <p className="text-14">{text}</p>
            <button
              onClick={() => {
                handleGDPRAnswer(UserUpdateGdprConsent.News)
              }}
              className="text-14 m-[auto] flex h-[45px] w-fit items-center rounded bg-gradient-to-b from-[#8beb6a] to-[#1d9166] px-5 font-bold uppercase text-white outline-none hover:bg-gradient-to-b hover:from-[#51bd2b] hover:to-[#118258]"
            >
              {buttonText}
            </button>
            <div className="flex flex-col items-center text-[11px]">
              <span
                className="cursor-pointer underline"
                onClick={() => handleGDPRAnswer(UserUpdateGdprConsent.None)}
              >
                {closeText}
              </span>
              <span>{footerText}</span>
            </div>
          </div>
        </Dialog.Body>
      </Dialog.Root>
    </div>
  )
}
